import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ServiceBase } from './service-base';
import { CookieService } from 'ngx-cookie-service';
import { CookiesLocalService } from './cookies-local.service';


@Injectable({
    providedIn: 'root'
})
export class BehaviorModelChangeService extends ServiceBase {
    defaultProgressValue:number=20;
    private loginLayoutTitleBehavior = new BehaviorSubject('');
    private sideBarClassChangeBehavior = new BehaviorSubject('app sidebar-mini rtl pace-done');
    private titleBehavior = new BehaviorSubject('Loading..');
    private userPictureBehavior = new BehaviorSubject(this.currentApplicantData==null ?'':this.currentApplicantData.PhotoUrl);
    private completionStateBehavior = 
    new BehaviorSubject(
        {message:"Upload Image:  | Personal Info:  | Examination Data: | Programme Choice: ",
         value:0,
         textClass:this.getClassName(this.defaultProgressValue),
         progressClass:this.getProgressClassName(this.defaultProgressValue)
        }
        );




    loginLayoutTitle = this.loginLayoutTitleBehavior.asObservable();
    title = this.titleBehavior.asObservable();
    sideBar = this.sideBarClassChangeBehavior.asObservable();
    userPicture = this.userPictureBehavior.asObservable();
    completionState = this.completionStateBehavior.asObservable();


    constructor(http:HttpClient,cookieService:CookieService,cookieLocal:CookiesLocalService) 
    { super(http,cookieService,cookieLocal);}


    onChangeLoginLayoutTitle(newTitle: string) {
        this.loginLayoutTitleBehavior.next(newTitle);
    }
    onChangeTitle(newTitle: string) {
        this.titleBehavior.next(newTitle);
    }

    onsideBarChange(className: string) {
        this.sideBarClassChangeBehavior.next(className);
    }

    onUserPictureChanged(imagePath: string) {
        this.userPictureBehavior.next(imagePath);
    }

    onUpdateProgressBar(model:any[]) {

        let message=`Upload Image: ${model[0].message} | Personal Info: ${model[1].message} | Examination Data: ${model[2].message} | Programme Choice: ${model[3].message}`
       
        let total=model[0].value+model[1].value+model[2].value+model[3].value +this.defaultProgressValue;


        this.completionStateBehavior.next({message:message,value:total,
            textClass:this.getClassName(total),
            progressClass:this.getProgressClassName(total)
        });
    }



    getClassName(value){
        if(value<=20) return 'text-danger';
        if(value<40) return 'text-black';
        if(value<60) return 'text-blue';
        if(value<100) return 'text-yellow';
        if(value>=100) return 'text-success';
    } 
    getProgressClassName(value){

        let d='progress-bar progress-bar-striped progress-bar-animated';
        if(value<=20) return    d+ ' progress-text-danger';
        if(value<40) return    d+ ' progress-text-black';
        if(value<60) return    d+ ' progress-text-blue';
        if(value<100) return   d+ ' progress-text-yellow';
        if(value>=100) return  d+ ' progress-text-success';
    }

}
